
import axios from 'axios';
import Config from './Config'
import {mapState} from "vuex";
import AuthService from "@/mixins/AuthService";
import {alertController, loadingController} from "@ionic/vue";

export default {
  name: 'EoppService',
  mixins: [
    Config,
    AuthService
  ],
  data() {
    return {
      loading: null
    }
  },
  methods: {
    init: function () {
      // console.log(this.quizAnswers);
      // if ( !this.leadinfoa ) {
      //     this.getAccountLead().then(res => {
      //         console.log(res.data);
      //         this.$store.commit('leadinfo', res.data);
      //     })
      // }
    },
    async showLoading(duration = 5000, message = 'Loading Data.....') {
      this.loading = await loadingController.create({
        message: message,
        duration: duration
      });
      this.loading.present();
    },
    async hideLoading(){
      if ( this.loading) {
        this.loading.dismiss();
        this.loading = null;
      }
    },

    async presentAlert( header, subHeader, message) {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: header,
          subHeader: subHeader,
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

      const {role} = await alert.onDidDismiss();
      console.log('onDidDismiss resolved with role', role);
    },
    async presentAlertConfirm(header, message) {
      return new Promise( (resolve) => {
        alertController.create({
          cssClass: 'my-custom-class',
          header: header,
          message: message,
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary',
              id: 'cancel-button',
              handler: blah => {
                console.log('Confirm Cancel:', blah)
                resolve(false);
              },
            },
            {
              text: 'Okay',
              id: 'confirm-button',
              handler: () => {
                console.log('Confirm Okay');
                resolve(true);
              },
            },
          ],
        }).then(alert => {
          alert.present();
        })
      });
      // return alert.present();
    },
    getQuiz: function (type=null){
      let url = this.config.apiBaseUrl + `/data/quiz?type=${type}`;
      return axios.get(url);
    },
    getPrevQuizItem: function(code) {
      if ( this.prevQuiz ) {
        return (this.prevQuiz || []).find(o => o.code === code);
      } else {
        return null;
      }
    },
    getCountries: function () {
      let url = this.config.apiBaseUrl + '/data/countries';

      return axios.get(url);
    },
    getData: function (dataUrl) {
      let url = this.config.apiBaseUrl + dataUrl;

      return axios.get(url);
    },
    postData: function (url, data) {
      let fullUrl = `${this.config.apiBaseUrl}/${url}`;
      return axios.post(fullUrl, data);
    },
    getCRMData: function (dataUrl) {
      let url = this.config.apiBaseUrl_CRM  + dataUrl;
      return this.getDataWithAuth(url);
    },
    deleteCRMData: function (dataUrl, param) {
      let url = this.config.apiBaseUrl_CRM  + dataUrl;
      return this.deleteDataWithAuth(url, param);
    },
    postCRMData: function (url, data) {
      let fullUrl = `${this.config.apiBaseUrl_CRM}/${url}`;
      return this.postDataWithAuth(fullUrl, data);
    },
    getAccountLead: function () {
      let url = this.config.apiBaseUrl_CRM + '/crm/account/lead';
      return this.getDataWithAuth(url);
    },
    getAccountDocuments: function () {
      let url = this.config.apiBaseUrl_CRM + '/crm/account/documents';
      return this.getDataWithAuth(url);
    },
    deleteAccountDocument: function (doc) {
      let url = this.config.apiBaseUrl_CRM + '/crm/account/documents';

      return this.deleteDataWithAuth(url, {id: doc.id});
    },
    getDataWithAuth: function (url) {
      return new Promise((resolve, reject) => {
        this.isAuthenticated().then(auth => {
          if (auth) {
            axios.get(url, {
              headers: {
                'Authorization': auth.signInUserSession.idToken.jwtToken
              }
            }).then(res => resolve(res),
              err => reject(err));
          } else {
            reject('Not Logged In');
          }
        }, err => reject(err));

      })

    },
    postDataWithAuth: function (url, data) {
      return new Promise((resolve, reject) => {
        this.isAuthenticated().then(auth => {
          if (auth) {
            axios.post(url, data, {
              headers: {
                'Authorization': auth.signInUserSession.idToken.jwtToken
              }
            }).then(res => resolve(res),
              err => reject(err));
          } else {
            reject('Not Logged In');
          }
        }, err => reject(err));
      })
    },
    deleteDataWithAuth: function (url, params) {
      console.log(params)
      return new Promise((resolve, reject) => {
        this.isAuthenticated().then(auth => {
          if (auth) {
            axios.delete(url,  {
              headers: {
                'Authorization': auth.signInUserSession.idToken.jwtToken
              },
              params
            }).then(res => resolve(res),
              err => {
                console.log(err)
                reject(err)
              });
          } else {
            reject('Not Logged In');
          }
        }, err => reject(err));

      })

    },
    postContactUs: function (data, recaptcha) {
      let url = `${this.config.apiBaseUrl}/signup/contact-us?recaptcha=${recaptcha}`;
      console.log(data);

      data.first_name = data.name.split(' ')[0];
      data.last_name = data.name.substring(data.first_name.length);

      let req = {
        type: 'Contact-US',
        user: data
      };

      return axios.post(url, req);
    },
    updateCrmRecord: function (data, recaptcha) {
      let url = `${this.config.apiBaseUrl}/enrol/update?recaptcha=${recaptcha}`;

      return axios.post(url, data);
    },
    toast: async function (title, message) {
      console.log(title, message)
    },
    getHints: function (code) {
      return (this.lead.cf.possible.find(o => o.program === code) || {}).hints;
    }
  },
  computed: {
    // lead () {
    //   if ( this.$store.state.leadInfo ){
    //     return this.$store.state.leadInfo.lead;
    //   } else {
    //     return null
    //   }
    // },
    qualifiedPrograms() {
      if (this.lead && this.leadInfo.products) {
        return (this.leadInfo.products || []).filter(o => (this.lead.cf.results || []).find(p => p.program === o.code) != null);
      } else {
        return []
      }
    },
    possiblePrograms() {
      if (this.lead && this.leadInfo.products) {
        return (this.leadInfo.products || []).filter(o => (this.lead.cf.possible || []).find(p => p.program === o.code) != null);
      } else {
        return []
      }
    },
    preferredProgram() {
      if (this.lead && this.leadInfo.products) {
        let prfProg = null;
        if (this.lead.cf.pref_program) {
          prfProg = (this.leadInfo.products || []).find(o => o.code === this.lead.cf.pref_program)
        // } else if (this.lead.cf.results.length > 0) {
        //   prfProg = (this.leadInfo.products || []).find(o => o.code === this.lead.cf.results[0].program)
        }
        return prfProg;
      } else {
        return null
      }
    },
    ...mapState({
      leadInfo: state => state.leadInfo,
      quizAnswers: state => state.quizAnswers,
      eduAnswers: state => state.eduAnswers,
      langAnswers: state => state.langAnswers,
      signupInfo: state => state.signupInfo,
      signupId: state => state.signupId,
      prevSignupInfo: state => state.prevSignupInfo,
      prevQuiz: state => state.prevQuiz,
      lead: state => (state && state.leadInfo) ? state.leadInfo.lead : null
    })
  },

}
